module.exports = __webpack_public_path__ + "static/Holiday_Mobile-2f2fbcfcb2c8c6e95a0c951980be87d7.webp";